module.exports = "/assets/logout.svg";